module.exports = __webpack_public_path__ + "static/media/gunkan.a50ff0e8.jpeg";